import { css } from 'styled-components';
import { getSpacing, SpacingName, rgba } from '../../theme';
import { BreakpointQueryName } from '../../theme/breakpoints';
export let ModalSize = /*#__PURE__*/function (ModalSize) {
  ModalSize["FULL"] = "FULL";
  ModalSize["XLARGE"] = "XL";
  ModalSize["LARGE"] = "L";
  ModalSize["MEDIUM"] = "M";
  ModalSize["SMALL"] = "S";
  return ModalSize;
}({});
const maxWidths = {
  S: '25rem',
  M: '50rem',
  L: '70rem',
  XL: '95rem',
  FULL: '100%'
};
export const basic = _ref => {
  let {
    theme,
    $open
  } = _ref;
  return css(["position:fixed;top:0;bottom:0;left:0;right:0;z-index:", ";visibility:", ";"], theme.zIndex.modal, $open ? 'visible' : 'hidden');
};
export const overlay = _ref2 => {
  let {
    theme,
    role,
    $open
  } = _ref2;
  return css(["z-index:1;position:absolute;top:0;bottom:0;left:0;right:0;background-color:", ";visibility:hidden;transition:all 0.2s ease-in-out;opacity:.3;", " ", ""], rgba(theme.palettes.neutrals.darkest, 0.6), $open && `
    opacity: 1;
    visibility: visible;
  `, role === 'button' && `
    cursor: pointer;
  `);
};
export const wrapper = _ref3 => {
  let {
    theme,
    $size,
    $loading,
    $open
  } = _ref3;
  return css(["position:relative;z-index:3;width:100%;margin:0 auto;height:100%;box-sizing:border-box;display:flex;align-items:center;transform:scale(0.9);opacity:0;visibility:hidden;", " ", "{max-width:", ";", "}"], $open && !$loading && `
    opacity: 1;
    visibility: visible;
    transform: scale(1);
    transition: all 0.1s ease-in-out;
  `, theme.breakpoints.up(BreakpointQueryName.LG), maxWidths[$size], $size !== ModalSize.FULL && `
      padding: ${theme.spaceUnits.desktop.BIG} ${theme.spaceUnits.desktop.SMALL};
    `);
};
export const modalStyle = _ref4 => {
  let {
    theme,
    $fillAvailableHeight,
    $height,
    $size
  } = _ref4;
  return css(["position:relative;display:flex;flex-direction:column;box-sizing:border-box;height:100%;width:100%;justify-content:center;background-color:", ";box-shadow:0 4px 8px 0 ", ";", "{max-height:", ";", " ", "}"], theme.palettes.neutrals.lightest, rgba(theme.palettes.neutrals.darkest, 0.5), theme.breakpoints.up(BreakpointQueryName.LG), $size === ModalSize.FULL ? '100vh' : '90vh', !$fillAvailableHeight && $size !== ModalSize.FULL && `
      height: auto;
    `, $height && `
      height: ${$height};
    `);
};
export const loadingStyle = _ref5 => {
  let {
    theme
  } = _ref5;
  return css(["", " height:100%;width:100%;display:flex;align-items:center;justify-content:center;z-index:2;position:relative;"], getSpacing.padding(theme, SpacingName.BIG));
};
export const modalSavingSpinner = _ref6 => {
  let {
    theme
  } = _ref6;
  return css(["background-color:", ";top:0;bottom:0;left:0;right:0;display:flex;align-items:center;justify-content:center;position:absolute;z-index:5;"], rgba(theme.palettes.neutrals.lightest, 0.6));
};
//# sourceMappingURL=Modal.style.js.map